<script setup lang="ts">
// Mobile-only sticky summary for the Additional Information step. Collapsed it shows just the headline
// figure (no payment toggle); expanding reveals the full QuoteSummary (monthly/annual toggle + cover
// premiums), minus the "Why insure with us" block. Desktop keeps the sidebar summary (see Factory).
import { ref, computed } from 'vue';
import { useSingleSchemeSummary } from './useSingleSchemeSummary';
import QuoteSummary from './QuoteSummary.vue';

const { price, total, isMonthly, monthly, isMta, plan } = useSingleSchemeSummary();

const expanded = ref(false);

// Headline mirrors the quote-display bottom dock: monthly instalment on the monthly plan, else the total.
const amount = computed(() => (isMonthly.value && monthly.value ? monthly.value.amount : total.value));
const label = computed(() => isMonthly.value ? 'Monthly' : (isMta.value ? (total.value < 0 ? 'Refund due' : 'Adjustment') : 'Total'));
</script>

<template>
    <div class="ra-dock" :class="{ open: expanded }">
        <div class="ra-dock-panel" v-show="expanded">
            <QuoteSummary readonly hide-why title="Summary" />
        </div>
        <button type="button" class="ra-dock-bar" :aria-expanded="expanded" @click="expanded = !expanded">
            <span class="ra-dock-total">
                <small>{{ label }}</small>
                <b>{{ price(Math.abs(amount)) }} <span class="ra-dock-incl">incl. IPT</span></b>
                <span v-if="isMonthly && plan && plan.deposit > 0" class="ra-dock-dep">Deposit {{ price(plan.deposit) }}</span>
            </span>
            <span class="ra-dock-toggle">
                {{ expanded ? 'Hide' : 'Details' }}
                <em class="far fa-chevron-up ra-dock-chev"></em>
            </span>
        </button>
    </div>
</template>
